import React, { ComponentProps, ElementType, ForwardedRef, forwardRef, HTMLAttributes, PropsWithChildren } from 'react';
import styled, { CSSProperties } from 'styled-components';

export interface ResponsiveStyle extends HTMLAttributes<HTMLOrSVGElement> {
    xs?: CSSProperties;
    sm?: CSSProperties;
    md?: CSSProperties;
    lg?: CSSProperties;
}

type StyledComponentProps<E extends ElementType> = PropsWithChildren<ResponsiveStyle> &
    ComponentProps<E> & {
        as?: E;
    };
const StyledComponent = styled.div(({ xs, sm, md, lg }: ResponsiveStyle) => ({
    ...xs,
    '@media (min-width: 600px)': { ...sm },
    '@media (min-width: 900px)': { ...md },
    '@media (min-width: 1200px)': { ...lg },
}));
const Element = <E extends ElementType = 'div'>(
    { as = 'div', children, ...props }: StyledComponentProps<E>,
    ref: ForwardedRef<HTMLElement>,
) => {
    return (
        <StyledComponent ref={ref} as={as} {...props}>
            {children}
        </StyledComponent>
    );
};

export default forwardRef(Element);
